export const showKioskSetupSelector = (state) => state.sharedReducer.showKioskSetup;
export const storeCategoriesSelector = (state) => state.sharedReducer.storeCategories;
